import React, { useState } from "react";
import LoadingSpinner from "../../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function DeleteEventModal({ event, cancelModal, fetchdata }) {
  const [isLoading, setIsLoading] = useState(false);
  const [complete,setComplete] = useState(false)
  const {user} = useAuthContext();
  //styled
  const handleConfirm = async () => {
    try {
      setIsLoading(true);
  
      const deleteResponse = await axios.delete(`${ApiConnectionString}/api/event/${event.id}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });
  
      if (deleteResponse.status === 200) {
        setComplete(true);
        fetchdata();
      }
    } catch (error) {
      console.error("Error deleting event:", error);
      // Handle error (e.g., show an error message)
    } finally {
      setIsLoading(false); // Stop loading in all cases
    }
  };
  

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  }else
if(complete){
    return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Delete Class</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>
           <p>The class has been deleted successfully.</p>

    
            <div className="send-modal-footer">
              <button  className="pointer cancelButton fw-bold mx-2 px-3" onClick={() => {setComplete(true); cancelModal()}}>
               Okay
              </button>
        
            </div>
          </div>
        </div>
      );
}else{
    return (
        <div className="send-modal-overlay">
          <div className="send-modal">
          <div className='blueBanner'><p className='fw-bold m-2 p-2 fontSize20'>Delete Class</p></div> 

<button
             type="button"
             className="close-button"
             onClick={cancelModal}
             aria-label="Close"
           >
             &times;
           </button>
           <table>
  <tbody>
    <tr>
      <td className="red-text"><strong>Class:</strong></td>
      <td>{event.name}</td>
    </tr>
    <tr>
      <td className="red-text"><strong>Description:</strong></td>
      <td>{event.description}</td>
    </tr>
    <tr>
      <td className="red-text"><strong>Time:</strong></td>
      <td>{event.timeIn} - {event.timeOut}</td>
    </tr>
  </tbody>
</table>
            <p className="text-danger">
              Deleting this class will automatically refund tokens to anyone who has
              booked into any future occurrences of the class
            </p>
            <div className="send-modal-footer">
              <button className="delete-button mx-3" onClick={handleConfirm}>
                Confirm
              </button>
              <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Cancel
                </button>

            </div>
          </div>
        </div>
      );
}
  }
  

